import { useBuilding } from '../../../context/BuildingContext';
import './floor.css';
import { logger } from '../../../utils/logger';

const Floor = ({ floorAmount }) => {
  const { selectedFloor, setSelectedFloor } = useBuilding();

  const handleFloorChange = (event) => {
    logger.debug('sset flore ');

    const floor = parseInt(event.target.value);
    setSelectedFloor(floor);
    localStorage.setItem('selectedFloor', floor);
  };

  return (
    <div className="floorContainer">
      <div className="select-wrapper">
        <h4>этаж</h4>
        <select onChange={handleFloorChange} value={selectedFloor}>
          {[...Array(floorAmount).keys()].map((floorNum) => (
            <option key={floorNum + 1} value={floorNum + 1}>
              {floorNum + 1}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default Floor;
